import React, { useEffect, useState } from 'react';
import PageContentWrapper from '../../components/PageContentWrapper';
import { AutoComplete, Button, DatePicker, Form, Radio, Select } from 'antd';
import { ArrowRightOutlined, SaveOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { getParticipants, getTrainings } from '../../appRedux/actions';
import moment from 'moment';
import { getRooms, getRoomsByDates, roomsBook } from '../../appRedux/actions/Booking';
import { useHistory } from 'react-router-dom';
const { RangePicker } = DatePicker;


export default function NewReservationsPage() {
  const [form] = Form.useForm()
  const [submitLoading, setSubmitLoading] = useState(false)
  const [rooms, setRooms] = useState([])
  const [checkInDate, setCheckInDate] = useState("")
  const [checkOutDate, setCheckOutDate] = useState("")
  const [searchParticipants, setSearchParticipants] = useState("");
  // const [participantId, setParticipantId] = useState(null)
  const history = useHistory();

  const dispatch = useDispatch();
  const { participants, participantsLoading } = useSelector(
    ({ participant }) => participant
  );

  useEffect(() => {
    setRoomsDisabled()
  }, [])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      dispatch(getParticipants({ page_size: 10, search: searchParticipants }));
    }, 200);
    return () => clearTimeout(timeoutId);
  }, [searchParticipants])

  function setRoomsDisabled() {
    setRooms([
      { "number": 1, "booked": true },
      { "number": 2, "booked": true },
      { "number": 3, "booked": true },
      { "number": 4, "booked": true },
      { "number": 5, "booked": true },
      { "number": 6, "booked": true },
      { "number": 7, "booked": true },
      { "number": 8, "booked": true },
      { "number": 9, "booked": true },
      { "number": 10, "booked": true },
      { "number": 11, "booked": true },
      { "number": 12, "booked": true }
    ])
  }

  function getAllRooms(start, end) {
    setRoomsDisabled()
    getRoomsByDates(
      moment(start, "dddd, D MMMM YYYY").format("YYYY-MM-DD"),
      moment(end, "dddd, D MMMM YYYY").format("YYYY-MM-DD")
    ).then(data => {
      setRooms(data)
      form.setFieldsValue({ room_number: null })
    })
  }

  return <>
    <PageContentWrapper
      ghost={false}
      title="Tambah Reservasi Kamar Inap"
      backLink={"/reservations"}
    >
      <Form
        scrollToFirstError={true}
        form={form}
        layout="vertical"
        onFinish={(values) => {
          setSubmitLoading(true)
          const name = participants.find((p) => p.id === values.participant_id).name
          roomsBook({
            start: moment(checkInDate, "dddd, D MMMM YYYY").format("YYYY-MM-DD"),
            end: moment(checkOutDate, "dddd, D MMMM YYYY").format("YYYY-MM-DD"),
            // participant_id: participantId,
            name: name,            
            ...values
          }).then(() => {
            setSubmitLoading(false)
            history.push("/reservations")
          }).catch((e) => {
            setSubmitLoading(false)
          })
        }}>
        <Form.Item
          label="Peserta"
          name="participant_id"
          rules={[{ required: true, message: "Mohon pilih peserta" }]}
        >
          <Select
            showSearch
            placeholder="pilih peserta"
            onSearch={setSearchParticipants}
            filterOption={false}
            notFoundContent={null}
            loading={participantsLoading}
            onChange={setRoomsDisabled}
          >
            {participants.map((p) => (
              <Select.Option key={p.id} value={p.id}>
                {p.name} {`(${p.email})`} {p.whatsapp_number === null ? "- (Peserta tidak memiliki nomor whatsapp)" : ""}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Tanggal Checkin dan Checkout"
          name="dates"
          rules={[{ required: true, message: "Mohon pilih tanggal checkin dan checkout" }]}>
          <RangePicker
            format="dddd, D MMMM YYYY"
            disabledDate={(current) => {
              return current < moment().subtract(1, 'days')
            }}
            onChange={(dates) => {
              if (dates && dates.length > 0) {
                const start = moment(dates[0]).format("dddd, D MMMM YYYY")
                const end = moment(dates[1]).format("dddd, D MMMM YYYY")
                setCheckInDate(start)
                setCheckOutDate(end)
                getAllRooms(start, end)
              }
            }} />
        </Form.Item>
        <Form.Item
          label="Pilih Nomor Kasur (no.1-6 kasur bawah, no.7-12 kasur atas).
                Mohon maaf jika fasilitas seadanya"
          name="room_number"
          rules={[{ required: true, message: "Mohon pilih nomor kasur" }]}
        >
          <Radio.Group optionType="button" buttonStyle="solid" options={rooms.map((room => {
            return {
              label: room.number,
              value: room.number,
              disabled: room.booked,
            }
          }))} onChange={(e) => {
            form.setFieldsValue({ room_number: e.target.value })
          }} />
          <p>
            Waktu Checkin : {checkInDate} jam 18.00 WIB<br />
            Waktu Checkout : {checkOutDate} jam 13.00 WIB
          </p>
        </Form.Item>
        <Form.Item>
          <center>
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              loading={submitLoading}
              icon={<SaveOutlined />}
            >
              Simpan
            </Button>
          </center>
        </Form.Item>
      </Form>
    </PageContentWrapper>
  </>
}
